import React from 'react';

import ImpactStatGroup from './ImpactStatGroup';
import ProductionScroll from './ProductionScroll';

const desc = `My World of Bags kicked off production in October 2020, and began to produce different types of personal protective equipment.
        
        By June 2021, 2 million and 575,000 items had been produced across hundreds of micro, small and large garment and accessory manufacturing factories in Ibadan and Lagos.`;

const ProductionTotal = () => {
	return (
		<section id="production-total">
			<div className="container">
				<ImpactStatGroup number="" unit="" description={desc} flex={true} />
			</div>
			<ProductionScroll />
		</section>
	);
};

export default ProductionTotal;
